import { Component, OnInit, OnDestroy, Inject, HostListener } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PrivacyPolicyService } from '../../projects';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'lib-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit, OnDestroy {
  privacyFlag: boolean;
  termsFlag: boolean;
  tandcView: boolean = false;
  privacyPolicyView: boolean = false;
  submitted: boolean = false;
  closed: boolean = false;
  enableActionFirst: boolean = false;
  enableActionSecond: boolean = false;
  scrollBoth: boolean = false;
  scrollTnC: boolean = false;
  scrollPrivacy: boolean = false;
  consentData: Array<any> = [];
  checkFlag: any = {};
  termsData: any;
  privacyData: any;
  indexValue:number=0;
  policyData:Array<any>=[];
  consentValueCheck:any={};
  constructor(public dialogRef: MatDialogRef<PrivacyPolicyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private apiURL: PrivacyPolicyService) { }
  @HostListener("window:scroll", [])
  ngOnInit() {
    if(!!localStorage.getItem('policyData')){
      this.policyData = JSON.parse(localStorage.getItem('policyData'));
      if (this.policyData.length) {
        this.consentValueCheck = this.policyData.find(res => res.appId == this.apiURL.appID).policyAgreement;
        if(Object.keys(this.consentValueCheck).length){
          if(!this.consentValueCheck.privacyFlag && !this.consentValueCheck.termsFlag){
            this.scrollBoth = true;
            this.scrollTnC = false;
            this.scrollPrivacy = false;
          }

          if(this.consentValueCheck.privacyFlag && !this.consentValueCheck.termsFlag){
            this.scrollBoth = false;
            this.scrollTnC = true;
            this.scrollPrivacy = false;
          }

          if(!this.consentValueCheck.privacyFlag && this.consentValueCheck.termsFlag){
            this.scrollBoth = false;
            this.scrollTnC = false;
            this.scrollPrivacy = true;
          }

          if(this.consentValueCheck.privacyFlag && this.consentValueCheck.termsFlag){
            this.dialogRef.close({ event: 'concentcancel' });
          }
        }
      }
    }else{
      this.dialogRef.close({ event: 'concentcancel' });
    }
    this.loadData();
  }

  loadData() {
    const privacyData = {
      country: localStorage.getItem('countryVal') ? localStorage.getItem('countryVal') : "",
      language: localStorage.getItem('countryVal') ? localStorage.getItem('countryVal').toLowerCase() : "",
      appId: this.apiURL.appID
    }
    if (!!localStorage.getItem('Lang')) {
      privacyData.language = localStorage.getItem('Lang');
    }
    if(privacyData.language == 'au'){
      privacyData.language = 'en';
    }
    forkJoin([
      this.apiURL.getPrivacyPolicyByCountry(privacyData),
      this.apiURL.getTermsByCountry(privacyData)
    ]).subscribe(([privacyData, termsData]) => {
      if (privacyData) {
        this.privacyData = atob(privacyData.document);
      }
      if (termsData) {
        this.termsData = atob(termsData.document);
      }
    })
  }
  updateCheckedOptions(data) {
    if (data.checked) {
      this.tandcView = false;
    }
  }
  updateCheckedPolicyOptions(data) {
    if (data.checked) {
      this.privacyPolicyView = false;
    }
  }
  updateDetails() {
    this.submitted = true;
    const formData = {
      appId: this.apiURL.appID,
      userId: localStorage.getItem('user_token'),
      privacyFlag: this.privacyFlag,
      privacyAcceptedDate: new Date(),
      termsFlag: this.termsFlag,
      termsAcceptedDate: new Date(),
      country: localStorage.getItem('countryVal')
    }
    if(this.consentValueCheck.privacyFlag){
      this.privacyFlag = true;
      formData.privacyFlag = this.consentValueCheck.privacyFlag;
      formData.privacyAcceptedDate = this.consentValueCheck.privacyAcceptedDate;
    }
    if(this.consentValueCheck.termsFlag){
      this.termsFlag=true;
      formData.termsFlag = this.consentValueCheck.termsFlag;
      formData.termsAcceptedDate = this.consentValueCheck.termsAcceptedDate;
    }
    if (!this.termsFlag) {
      this.tandcView = true;
    }
    if (!this.privacyFlag) {
      this.privacyPolicyView = true;
    }
    if(!!this.tandcView || !!this.privacyPolicyView ){
      return false;
    }
    this.apiURL.updateTermsAndPolicy(formData, formData.appId).subscribe(data => {
      if (data) {
        if (!!localStorage.getItem('policyData')) {
          this.consentData = JSON.parse(localStorage.getItem('policyData'));
          this.checkFlag = this.consentData.find(res => res.appId == this.apiURL.appID).policyAgreement;
          if (Object.keys(this.checkFlag).length) {

            this.checkFlag.privacyFlag = true;
            this.checkFlag.termsFlag = true;
            localStorage.setItem('policyData', JSON.stringify(this.consentData));
            this.dialogRef.close({ event: 'submitted' });

          }
        }
      }
    })
  }
  onScroll(event): void {
    if ((Math.ceil(event.target.offsetHeight + event.target.scrollTop)+5) >= event.target.scrollHeight && !this.indexValue) {
      this.enableActionFirst = true;
      if(this.consentValueCheck.termsFlag){
        this.enableActionFirst = false;
        this.enableActionSecond = true;
      }
      if(this.consentValueCheck.privacyFlag){
        this.enableActionFirst = true;
        this.enableActionSecond = false;
      }
    }
    if ((Math.ceil(event.target.offsetHeight + event.target.scrollTop)+5) >= event.target.scrollHeight && !!this.indexValue) {
      this.enableActionSecond = true;
    }
  }
  onChangeEvent(event){
    this.indexValue = event;
  }
  ngOnDestroy() {
    this.enableActionFirst = false;
    this.enableActionSecond = false
  }
  onCloseDialog(): void {
    this.dialogRef.close({ event: 'concentcancel' });
  }
}
